export default __webpack_public_path__ + "static/media/footer_bg3.57a8ccda.jpg";